export default __webpack_public_path__ + "static/media/sample_lead.981954df.csv";